module.exports = __webpack_public_path__ + "img/bespoke70_20.67760183.jpg";